import {Component, Vue} from 'vue-property-decorator';
import {
  invoicesIcon,
  offersIcon,
  summeryIcon,
  usersIcon,
  businessIcon,
  ordersIcon,
  globeIcon, partnerIcon, customerIcon,
} from '@deanone/dean-components';
import axios from 'axios';

@Component({})
export default class SideMenuCustomerMixin extends Vue {
  public sideMenu: any = {};

  public buildSideMenuCustomer(id: string) {
    const sideMenu = this.$store.getters.getSideMenu;
    if (!sideMenu.content || sideMenu.content.lastId !== id || sideMenu.content.sideMenuName !== 'customer') {
      axios.post('/-/trade/api/customer.info', {
        customerId: id,
      }).then(
        (response: any) => {
          this.sideMenu = {
            content: {
              title: {
                text: `Klant ${response.data.name} (${response.data.code})`,
                mobile: {
                  close: {
                    text: 'Close',
                    icon: invoicesIcon,
                  },
                },
              },
              type: 'themed',
              sections: {
                general: {
                  title: 'Klantgegevens',
                  items: {
                    overview: {
                      title: 'Gegevens',
                      icon: summeryIcon,
                      name: 'customers.edit',
                      params: {id},
                    },
                  },
                },
              },
              sideMenuName: 'customer',
              lastId: id,
            },
          };

          if (this.$store.getters.getUser.privileges.includes('view-customer-address')) {
            this.sideMenu.content.sections.general.items['addresses'] = {
              title: 'Adressen',
              icon: businessIcon,
              name: 'customers.addresses.list',
              params: {pid: id},
            };
          }

          if (this.$store.getters.getUser.privileges.includes('view-customer-contact')) {
            this.sideMenu.content.sections.general.items['contacts'] = {
              title: 'Contacten',
              icon: usersIcon,
              name: 'customers.contacts.list',
              params: {pid: id},
            };

          }

          if (this.$store.getters.getUser.privileges.includes('view-customer-quote')) {
            this.sideMenu.content.sections.general.items['quotes'] = {
              title: 'Offertes',
              icon: offersIcon,
              name: 'customers.quotes.list',
              params: {pid: id},
            };
          }

          if (this.$store.getters.getUser.privileges.includes('view-customer-order')) {
            this.sideMenu.content.sections.general.items['orders'] = {
              title: 'Orders',
              icon: ordersIcon,
              name: 'customers.orders.list',
              params: {pid: id},
            };
          }

          if (this.$store.getters.getUser.privileges.includes('view-customer-service')) {
            this.sideMenu.content.sections.general.items['services'] = {
              title: 'Diensten',
              icon: globeIcon,
              name: 'customers.services.list',
              params: {pid: id},
            };
          }

          this.sideMenu.content.sections.general.items['partition'] = {
            title: 'Cloud PBX',
            icon: globeIcon,
            name: 'provisioning.partition.info',
            params: {customerId: id},
          };

          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error: any) => {
          this.$toast({
            theme: 'danger',
            text: 'Zijmenu kon niet ingeladen worden',
          });
        },
      );
    }
  }
}
